var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    fill: "#ABB2BF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 2,
    r: 2,
    fill: "#ABB2BF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 2,
    r: 2,
    fill: "#ABB2BF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 2,
    r: 2,
    fill: "#ABB2BF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 2,
    r: 2,
    fill: "#ABB2BF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 22,
    r: 2,
    fill: "#ABB2BF"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 2,
    fill: "#ABB2BF"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 22,
    r: 2,
    fill: "#ABB2BF"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 22,
    r: 2,
    fill: "#ABB2BF"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 22,
    r: 2,
    fill: "#ABB2BF"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 42,
    r: 2,
    fill: "#ABB2BF"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 42,
    r: 2,
    fill: "#ABB2BF"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 2,
    fill: "#ABB2BF"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 42,
    r: 2,
    fill: "#ABB2BF"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 42,
    r: 2,
    fill: "#ABB2BF"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 62,
    r: 2,
    fill: "#ABB2BF"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 62,
    r: 2,
    fill: "#ABB2BF"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 62,
    r: 2,
    fill: "#ABB2BF"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62,
    r: 2,
    fill: "#ABB2BF"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 62,
    r: 2,
    fill: "#ABB2BF"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 82,
    r: 2,
    fill: "#ABB2BF"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 82,
    r: 2,
    fill: "#ABB2BF"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 82,
    r: 2,
    fill: "#ABB2BF"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 82,
    r: 2,
    fill: "#ABB2BF"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 82,
    r: 2,
    fill: "#ABB2BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/Dots.6e33fd923b2a31d9872d96e676985fdd.svg";
export { ForwardRef as ReactComponent };